// extracted by mini-css-extract-plugin
export var banner = "_s4-0";
export var settingRow = "_s4-2";
export var titleIcon = "_s4-1";